<template>
  <div>
    <v-toolbar flat color="white">
      <v-btn color="primary" class="white--text" round @click="getKMZ()"
        >Download KML</v-btn
      >
      <v-spacer></v-spacer>
      <v-text-field v-model="searchLocation" id="pac-input"></v-text-field>
    </v-toolbar>
    <gmap-map
      ref="mapRef"
      :center="center"
      :zoom="zoom"
      :options="{
        styles: myStyles,
        streetViewControl: false,
      }"
      style="width: 100%; height: 85vh"
    >
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      >
        <v-card flat color="white" v-if="polyInfo.fno" width="450px">
          <v-toolbar flat :color="polyInfo.fno.primaryColour">
            <h3 class="title white--text">{{ polyInfo.name }}</h3>
          </v-toolbar>
          <v-card-text>
            <v-layout justify-center align-center wrap class="text-xs-left">
              <v-flex xs5 v-if="polyInfo.fno">
                <h3 class="grey--text">Network Operator:</h3>
              </v-flex>
              <v-flex xs7 v-if="polyInfo.fno">
                <h3 class="grey--text font-weight-light" color="grey">
                  {{ polyInfo.fno.name }}
                </h3>
              </v-flex>
              <v-flex
                xs5
                v-if="polyInfo.network && polyInfo.network.networkStatus"
              >
                <h3 class="grey--text">Network Status</h3>
              </v-flex>
              <v-flex
                xs7
                v-if="polyInfo.network && polyInfo.network.networkStatus"
              >
                <v-chip
                  v-if="polyInfo.network.networkStatus == 'Live'"
                  small
                  class="white--text"
                  color="light-green"
                  >Live</v-chip
                >
                <v-chip
                  v-else-if="polyInfo.network.networkStatus == 'In Progress'"
                  small
                  class="white--text"
                  color="blue"
                  >In Progress</v-chip
                >
                <v-chip
                  v-else-if="polyInfo.network.networkStatus == 'Planned'"
                  small
                  class="white--text"
                  color="orange"
                  >Planned</v-chip
                >
              </v-flex>
              <v-flex
                xs5
                v-if="polyInfo.network && polyInfo.network.backhaulType"
              >
                <h3 class="grey--text">Backhaul Type</h3>
              </v-flex>
              <v-flex
                xs7
                v-if="polyInfo.network && polyInfo.network.backhaulType"
              >
                <h3 class="grey--text font-weight-light" color="grey">
                  {{ polyInfo.network.backhaulType }}
                </h3>
              </v-flex>
              <v-flex xs5 v-if="polyInfo.units">
                <h3 class="grey--text">No. of Units:</h3>
              </v-flex>
              <v-flex xs7 v-if="polyInfo.units">
                <h3 class="grey--text font-weight-light" color="grey">
                  {{ polyInfo.units }}
                </h3>
              </v-flex>
              <v-flex xs5 v-if="polyInfo.connected">
                <h3 class="grey--text">Units Connected:</h3>
              </v-flex>
              <v-flex xs7 v-if="polyInfo.connected">
                <h3 class="grey--text font-weight-light" color="grey">
                  {{ polyInfo.connected }}
                </h3>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </gmap-info-window>
    </gmap-map>
  </div>
</template>

<script>
import Api from "../services/Api";
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
  components: {
    googleAutoComplete: VueGoogleAutocomplete,
  },
  data() {
    return {
      center: { lng: -33.919473, lat: 18.427059 },
      geoData: {},
      markers: [],
      places: [],
      polyInfo: {},
      map: undefined,
      markerData: {},
      currentPlace: null,
      item: {},
      key: 0,
      myCityData: null,
      networkPolygons: [],
      itemModal: false,
      infoContent: "",
      myStyles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ],
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      searchLocation: "",
      zoom: 13,
    };
  },

  mounted() {
    this.geolocate();
  },
  async created() {
    await this.getNetworkPolygons();
  },

  methods: {
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData;
    },
    getKMZ() {
      Api()
        .post("/downloadKML", this.geoData)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "coverage_map.kml");
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },
    async getNetworkPolygons() {
      await Api()
        .get("/locationNetworkPolygon/ownNetworks")
        .then(async (response) => {
          let geoObj = {
            type: "FeatureCollection",
            name: "Network Polygons",
            crs: {
              type: "name",
              properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
            },
            features: [],
          };
          let objects = response.data
          for (let x=0;x<objects.length;x++){
            let obj = {
            type: "Feature",
            properties: {
              name: objects[x].locationNetwork ? objects[x].locationNetwork.name : objects[x].name,
              fno: this.$store.state.currentOrg.org,
              network: objects[x],
              description: null,
              units: objects[x].locationNetwork
                ? objects[x].locationNetwork.numberOfUnits
                : objects[x].numberOfUnits,
              tessellate: 1
            },
            geometry: {
              type: "Polygon",
              coordinates: objects[x].coordinates?JSON.parse(objects[x].coordinates):[],
            }
            }
            if(obj.geometry.coordinates.length>0){
              if(obj.geometry.coordinates[0][0][0]!==obj.geometry.coordinates[0][obj.geometry.coordinates[0].length-1][0] ||
              obj.geometry.coordinates[0][0][1]!==obj.geometry.coordinates[0][obj.geometry.coordinates[0].length-1][1]
              ) {
                obj.geometry.coordinates[0].push(obj.geometry.coordinates[0][0])
              }
              geoObj.features.push(obj)
            }
          }
          this.geoData = geoObj;
          this.plotMap();
        });
    },
    plotMap() {
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.initMapAutocomplete();
        this.map = map;
        this.map.data.addGeoJson(this.geoData);
        this.map.data.setStyle(function (feature) {
          console.log(feature)
          let keys = Object.keys(feature)
                        let featureObject = null
                        for (let i = 0; i < keys.length; i++) {
                            if (typeof feature[keys[i]] == 'object') {
                                if (feature[keys[i]].network) {
                                    featureObject = feature[keys[i]]
                                }
                            }
                        }
          return {
            fillColor: featureObject.fno? featureObject.fno.primaryColour: 'green',
            fillOpacity: 0.3,
            strokeWeight: 2,
            strokeColor: featureObject.fno? featureObject.fno.primaryColour: 'green',

            styles: {
              featureType: "poi",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
          };
        });
        this.map.data.addListener("click", (event) => {
          this.polyInfo = {
            type: "Network",
            name: event.feature.i.name,
            units: event.feature.i.units,
            connected: event.feature.i.connected,
            fno: event.feature.i.fno,
            network: event.feature.i.network,
          };
          this.openWindow(event);
          let testPoly = new google.maps.Polygon({
            paths: event.feature.getGeometry().getAt(0).getArray(),
          });
          if (
            google.maps.geometry.poly.containsLocation(event.latLng, testPoly)
          ) {
            // This works now, still have to loop through the arrays for the multipolygons
          }
        });
      });
    },
    showDescPolygon(data) {
      // console.log(data);
    },
    isWithinPoly(event) {
      // console.log(event);
      var isWithinPolygon = google.maps.geometry.poly.containsLocation(
        event.latLng,
        this
      );
    },
    openWindow(data) {
      this.infoWindowPos = {
        lat: data.latLng.lat(),
        lng: data.latLng.lng(),
      };
      this.infoWinOpen = true;
    },
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },

    initMapAutocomplete() {
      let geocoder = new google.maps.Geocoder();

      const input = document.getElementById("pac-input");
      const autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.setComponentRestrictions({
        country: ["za"],
      });

      google.maps.event.addListener(autocomplete, "place_changed", () => {
        let curPlace = autocomplete.getPlace();
        this.center = curPlace.geometry.location;
        this.zoom = 18;
      });
    },
  },
};
</script>